var map = {
	"./v0.svg": "mhYR",
	"./v1.svg": "tdpD",
	"./v10.svg": "TWF8",
	"./v11.svg": "PF3Y",
	"./v2.svg": "L7rz",
	"./v3.svg": "2/pi",
	"./v4.svg": "3aRH",
	"./v5.svg": "Zjqa",
	"./v6.svg": "Xzov",
	"./v7.svg": "NDJs",
	"./v8.svg": "kqCc",
	"./v9.svg": "Ldat",
	"./v_back.svg": "JCr9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3Ya";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip ^\.\/v.*\.svg$
// module id = c3Ya
// module chunks = 0